import { InjectionToken } from '@angular/core';

declare global {
  interface Window {
    dataLayer: DataLayerMessage[];
  }
}

export interface GoogleTagManagerConfiguration {
  containerId: string;
  authentication?: string;
  preview?: string;
  cookies?: 'x';
}

export const GTM_CONFIG = new InjectionToken<GoogleTagManagerConfiguration>(
  'GTMConfig',
);

// When you add a member to this enum, also add the corresponding entry
// in `DataLayerMessage` below
export enum DataLayerEvent {
  Initialization = 'gtm.js',
  HistoryChanged = 'gtm.historyChange',
  AnalyticsConsent = 'analyticsConsent',
}

// Maps events to their message interface
export type DataLayerMessage = {
  [key in DataLayerEvent]: {
    [DataLayerEvent.HistoryChanged]: {};
    [DataLayerEvent.AnalyticsConsent]: {};
    [DataLayerEvent.Initialization]: { 'gtm.start': number };
  }[key] & { event: key };
}[DataLayerEvent];
